import { at } from 'lodash';
import { useField } from 'formik';
import TextField from '@mui/material/TextField';

export default function InputField(props) {
  const { label, ...rest } = props;
  const [field, meta] = useField(props);

  const [touched, error] = at(meta, 'touched', 'error');
  const isError = touched && Boolean(error);

  const fieldId = props.name;
  const helperId = `${fieldId}-helper-text`;

  return (
    <TextField
      {...field}
      {...rest}
      id={fieldId}
      label={label}
      variant="outlined"
      fullWidth
      error={isError}
      helperText={isError ? error : ''}
      FormHelperTextProps={{
        id: helperId,
      }}
      aria-describedby={isError ? helperId : undefined}
    />
  );
}
